import { render } from "./CurrentDate.vue?vue&type=template&id=31f8bc8e&ts=true"
import script from "./CurrentDate.vue?vue&type=script&lang=ts"
export * from "./CurrentDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__